var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 10.85c-3.43 0-7.27 2-7.6 2.69-.27.56-.4 2.3-.4 2.3 0 .64.54 1.16 1.2 1.16h13.6c.66 0 1.2-.52 1.2-1.15 0 0-.13-1.75-.4-2.31-.33-.7-4.17-2.7-7.6-2.7ZM9 7.15A3.08 3.08 0 1 0 9 1a3.08 3.08 0 0 0 0 6.15Z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgPerson;